import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import type { ProductComparisonProductCodeListRequestDTO } from "./dto";

const apiUrl = occUrl("/product-comparison/addProduct/bulk");

export function sendData(data: string[]) {
  return occFetch(apiUrl, {
    body: JSON.stringify({ productCodes: data } satisfies ProductComparisonProductCodeListRequestDTO),
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  }).then((res) => res);
}
